<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Contents">
<h1 class="chapter">
<span class="small1">Contents</span>
</h1>
<p class="extract" id="acka">
<a href="#/9780310412625_epub_ack_r1#ack">Acknowledgments</a>
</p>
<p class="nonindenttoc" id="c01a">
<a href="#/9780310412625_epub_c01_r1#c01">
<span class="sm2">CHAPTER 1</span>
<br/>    <span class="big2">
<em>Over the Mountain</em>
</span>
</a>
</p>
<p class="nonindenttoc" id="c02a">
<a href="#/9780310412625_epub_c02_r1#c02">
<span class="sm2">CHAPTER 2</span>
<br/>    <span class="big2">
<em>Daily Bread</em>
</span>
</a>
</p>
<p class="nonindenttoc" id="c03a">
<a href="#/9780310412625_epub_c03_r1#c03">
<span class="sm2">CHAPTER 3</span>
<br/>    <span class="big2">
<em>Through the Valley</em>
</span>
</a>
</p>
<p class="nonindenttoc" id="c04a">
<a href="#/9780310412625_epub_c04_r1#c04">
<span class="sm2">CHAPTER 4</span>
<br/>    <span class="big2">
<em>Wife of My Youth</em>
</span>
</a>
</p>
<p class="nonindenttoc" id="c05a">
<span href="#/9780310412625_epub_c05_r1#c05" title="Link target outside of Sample">
<span class="sm2">CHAPTER 5</span>
<br/>    <span class="big2">
<em>Answering the Call</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c06a">
<span href="#/9780310412625_epub_c06_r1#c06" title="Link target outside of Sample">
<span class="sm2">CHAPTER 6</span>
<br/>    <span class="big2">
<em>The Hour of Trial</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c07a">
<span href="#/9780310412625_epub_c07_r1#c07" title="Link target outside of Sample">
<span class="sm2">CHAPTER 7</span>
<br/>    <span class="big2">
<em>Fall of the Mighty</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c08a">
<span href="#/9780310412625_epub_c08_r1#c08" title="Link target outside of Sample">
<span class="sm2">CHAPTER 8</span>
<br/>    <span class="big2">
<em>Requiem</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c09a">
<span href="#/9780310412625_epub_c09_r1#c09" title="Link target outside of Sample">
<span class="sm2">CHAPTER 9</span>
<br/>    <span class="big2">
<em>The Dark Times</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c10a">
<span href="#/9780310412625_epub_c10_r1#c10" title="Link target outside of Sample">
<span class="sm2">CHAPTER 10</span>
<br/>    <span class="big2">
<em>Bugs and the Band</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c11a">
<span href="#/9780310412625_epub_c11_r1#c11" title="Link target outside of Sample">
<span class="sm2">CHAPTER 11</span>
<br/>    <span class="big2">
<em>Trudge to the Rappahannock</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c12a">
<span href="#/9780310412625_epub_c12_r1#c12" title="Link target outside of Sample">
<span class="sm2">CHAPTER 12</span>
<br/>    <span class="big2">
<em>A Carol for Caroline Street</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c13a">
<span href="#/9780310412625_epub_c13_r1#c13" title="Link target outside of Sample">
<span class="sm2">CHAPTER 13</span>
<br/>    <span class="big2">
<em>Plain of the Dead</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c14a">
<span href="#/9780310412625_epub_c14_r1#c14" title="Link target outside of Sample">
<span class="sm2">CHAPTER 14</span>
<br/>    <span class="big2">
<em>The Endless Night</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c15a">
<span href="#/9780310412625_epub_c15_r1#c15" title="Link target outside of Sample">
<span class="sm2">CHAPTER 15</span>
<br/>    <span class="big2">
<em>Tears in the Yuletide</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c16a">
<span href="#/9780310412625_epub_c16_r1#c16" title="Link target outside of Sample">
<span class="sm2">CHAPTER 16</span>
<br/>    <span class="big2">
<em>General Decline</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c17a">
<span href="#/9780310412625_epub_c17_r1#c17" title="Link target outside of Sample">
<span class="sm2">CHAPTER 17</span>
<br/>    <span class="big2">
<em>General Renewal</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c18a">
<span href="#/9780310412625_epub_c18_r1#c18" title="Link target outside of Sample">
<span class="sm2">CHAPTER 18</span>
<br/>    <span class="big2">
<em>A Grand Design</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c19a">
<span href="#/9780310412625_epub_c19_r1#c19" title="Link target outside of Sample">
<span class="sm2">CHAPTER 19</span>
<br/>    <span class="big2">
<em>The Inn at the Crossroad</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c20a">
<span href="#/9780310412625_epub_c20_r1#c20" title="Link target outside of Sample">
<span class="sm2">CHAPTER 20</span>
<br/>    <span class="big2">
<em>A Knock on the Head</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c21a">
<span href="#/9780310412625_epub_c21_r1#c21" title="Link target outside of Sample">
<span class="sm2">CHAPTER 21</span>
<br/>    <span class="big2">
<em>Northward Bound</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c22a">
<span href="#/9780310412625_epub_c22_r1#c22" title="Link target outside of Sample">
<span class="sm2">CHAPTER 22</span>
<br/>    <span class="big2">
<em>Northward Bound Again</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c23a">
<span href="#/9780310412625_epub_c23_r1#c23" title="Link target outside of Sample">
<span class="sm2">CHAPTER 23</span>
<br/>    <span class="big2">
<em>Bliss</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c24a">
<span href="#/9780310412625_epub_c24_r1#c24" title="Link target outside of Sample">
<span class="sm2">CHAPTER 24</span>
<br/>    <span class="big2">
<em>Dust and Ashes</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c25a">
<span href="#/9780310412625_epub_c25_r1#c25" title="Link target outside of Sample">
<span class="sm2">CHAPTER 25</span>
<br/>    <span class="big2">
<em>New Recruits</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c26a">
<span href="#/9780310412625_epub_c26_r1#c26" title="Link target outside of Sample">
<span class="sm2">CHAPTER 26</span>
<br/>    <span class="big2">
<em>Dry Powder</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c27a">
<span href="#/9780310412625_epub_c27_r1#c27" title="Link target outside of Sample">
<span class="sm2">CHAPTER 27</span>
<br/>    <span class="big2">
<em>Back to the Enemy</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c28a">
<span href="#/9780310412625_epub_c28_r1#c28" title="Link target outside of Sample">
<span class="sm2">CHAPTER 28</span>
<br/>    <span class="big2">
<em>Winter Quarters</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c29a">
<span href="#/9780310412625_epub_c29_r1#c29" title="Link target outside of Sample">
<span class="sm2">CHAPTER 29</span>
<br/>    <span class="big2">
<em>Eye to Eye</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c30a">
<span href="#/9780310412625_epub_c30_r1#c30" title="Link target outside of Sample">
<span class="sm2">CHAPTER 30</span>
<br/>    <span class="big2">
<em>A Season in the Wilderness</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c31a">
<span href="#/9780310412625_epub_c31_r1#c31" title="Link target outside of Sample">
<span class="sm2">CHAPTER 31</span>
<br/>    <span class="big2">
<em>The Mule Shoe</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c32a">
<span href="#/9780310412625_epub_c32_r1#c32" title="Link target outside of Sample">
<span class="sm2">CHAPTER 32</span>
<br/>    <span class="big2">
<em>Assault at Cold Harbor</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c33a">
<span href="#/9780310412625_epub_c33_r1#c33" title="Link target outside of Sample">
<span class="sm2">CHAPTER 33</span>
<br/>    <span class="big2">
<em>Her Husband’s Crown</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="c34a">
<span href="#/9780310412625_epub_c34_r1#c34" title="Link target outside of Sample">
<span class="sm2">CHAPTER 34</span>
<br/>    <span class="big2">
<em>Unto the Mountains</em>
</span>
</span>
</p>
<p class="nonindenttoc" id="atpa">
<span href="#/AboutthePublisher#atp" title="Link target outside of Sample">About the Publisher</span>
</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310412625_epub_toc_r1.vue?f07f8d02